import { useMutation } from 'react-query';
import { downloadRegisterResultFile } from 'apis/registerResult.api';
import { downloadOrViewPdfFile } from 'utils/func';

const useDownloadRegisterResultFileUpload = () =>
  useMutation({
    mutationFn: ({ id, filename, type }) => downloadRegisterResultFile(id, filename, type),
    onSuccess: (response, { filename }) => {
      if (response?.data) {
        const file = new Blob([response.data], {
          type: 'application/pdf',
        });

        downloadOrViewPdfFile(file, filename, true);
      }
    },
    onError: () => {},
  });

export default useDownloadRegisterResultFileUpload;
